// 3rd party libs
import React from 'react';
import cx from 'classnames';

// local imports
import EditIcon from '../../../assets/icons/edit-pen.svg';
import styles from './EditButton.module.scss';

type TEditButton = {
  onClick?: (e?: any) => void;
  className?: string;
};

const EditButton: React.FC<TEditButton> = ({ onClick, className }) => {
  return <img onClick={onClick} className={cx(styles.btn, className)} src={EditIcon} alt="edit icon" />;
};

export default EditButton;
